// extracted by mini-css-extract-plugin
export default {"close_icon_container":"CloseIcon_close_icon_container__r3UUQ","close_icon":"CloseIcon_close_icon__P2L+C"};